import type { StatModifier } from '../stats/StatSheet';

/**
 * Shared curse pool for cursed artifact procs. Rolled at drop pre-roll time
 * (loot stream); modifiers apply UNSCALED — never quality-scaled, never
 * doubled. A curse may overlap the artifact's own boon stat (net-weaker but
 * still positive) — accepted; rerolling on overlap would make loot-stream
 * draw counts data-dependent.
 */
export interface CurseDef {
  id: string;
  name: string;
  desc: string;
  modifiers: StatModifier[];
}

export const CURSE_POOL: CurseDef[] = [
  { id: 'leadLimbs', name: 'Lead Limbs', desc: '-10% move speed', modifiers: [{ stat: 'moveSpeed', pct: -0.1 }] },
  { id: 'thinBlood', name: 'Thin Blood', desc: '-1 max HP', modifiers: [{ stat: 'maxHp', flat: -1 }] },
  { id: 'rustedGears', name: 'Rusted Gears', desc: '+15% cooldowns', modifiers: [{ stat: 'cooldownMult', pct: 0.15 }] },
  { id: 'dimSight', name: 'Dim Sight', desc: '-15% ability area', modifiers: [{ stat: 'areaMult', pct: -0.15 }] },
  { id: 'dullEdge', name: 'Dull Edge', desc: '-10% damage', modifiers: [{ stat: 'damageMult', pct: -0.1 }] },
  { id: 'greedTithe', name: 'Greed Tithe', desc: '-20% gem gain', modifiers: [{ stat: 'gemGainMult', pct: -0.2 }] },
];

export const CURSES_BY_ID = new Map(CURSE_POOL.map((c) => [c.id, c]));
